<template>
  <li class="sm-phone__list-item">
    <div class="sm-phone__list-item-main">
      <h5 class="sm-phone__list-item-main-number">
        <!-- <span>{{formatPhoneNumber(phone)}}</span> -->
        <text-truncate :text="formatPhoneNumber(phone)" />
      </h5>
      <div class="sm-phone__list-item-main-country">
        <include-flag :country="getPhoneCountry(phone.phone_number)" />
        <span>{{getPhoneCountry(phone.phone_number)}}</span>
      </div>
    </div>
    <ul class="sm-phone__list-item-settings">
      <template v-if="viewPort == 'large'">
        <li>
          <include-svg :name="'icon-phone-extensions'" />
          <span>Extensions</span>
          <a
            href="#"
            class="sm-link"
            @click.prevent="showPopup(`ext-${extensions.length ? 'list' : 'new'}`)"
          >Add</a>
        </li>
        <li>
          <include-svg :name="'icon-phone-forwarding'" />
          <span>Setup</span>
          <a
            href="#"
            class="sm-link"
            @click.prevent="goToEdit"
          >Edit</a>
        </li>
        <li>
          <include-svg :name="'icon-phone-outgoing'" />
          <span>Outgoing calls</span>
          <a
            href="#"
            class="sm-link"
            @click.prevent="showPopup('out')"
          >Setup</a>
        </li>
        <li>
          <a
            href="#"
            class="sm-link sm-error"
            @click.prevent="showPopup('del')"
          >Cancel</a>
        </li>
      </template>
      <template v-else>
        <li @click="showPopup(`ext-${extensions.length ? 'list' : 'new'}`)">
          <hint-wrap :text="extActionText">
            <template slot="content">
              <include-svg :name="'icon-phone-extensions'" />
            </template>
          </hint-wrap>
        </li>
        <li @click="goToEdit">
          <hint-wrap :text="'Edit setup'">
            <template slot="content">
              <include-svg :name="'icon-phone-forwarding'" />
            </template>
          </hint-wrap>
        </li>
        <li @click="showPopup('out')">
          <hint-wrap :text="'Setup outgoing calls'">
            <template slot="content">
              <include-svg :name="'icon-phone-outgoing'" />
            </template>
          </hint-wrap>
        </li>
        <li @click="showPopup('del')">
          <hint-wrap 
            :text="'Cancel'"
          >
            <template slot="content">
              <include-svg :name="'icon-phone-delete'" />
            </template>
          </hint-wrap>
        </li>
      </template>
    </ul>
    <div 
      class="sm-phone__list-item-mobile"
      @click="showItemPopup(phone)"
    >
      <button 
        type="button"
        class="sm-phone__list-item-mobile-link"
      ></button>
      <ul 
        v-if="phone.popupOpen"
        class="sm-phone__list-item-mobile-popup"
        v-click-outside="hidePopups"
      >
        <li>
          <a 
            href="#"
            @click.prevent="showPopup(`ext-${extensions.length ? 'list' : 'new'}`)"
          >{{extActionText}}</a>
        </li>
        <li>
          <a 
            href="#"
            @click.prevent="goToEdit"
          >Edit setup</a>
        </li>
        <li>
          <a 
            href="#"
            @click.prevent="showPopup('out')"
          >Outgoing calls setup</a>
        </li>
        <li>
          <a
            href="#"
            @click.prevent="showPopup('del')"
          >Cancel phone</a>
        </li>
      </ul>
    </div>

    <popup-block
      v-if="popup.isOpen"
      :open="popup.isOpen"
      :size="popupSize"
      :class="'sm-phone__popup'"
      @close="popup.isOpen = false"
    >
      <template slot="popupContent">
        <form-extension
          v-if="popup.type == 'ext-new' || popup.type == 'ext-edit'"
          :title="popup.type == 'ext-new' ? 'Add extension' : 'Edit extension'"
          :btnText="popup.type == 'ext-new' ? 'Add' : 'Update'"
          :initData="popup.type == 'ext-edit' ? popup.item : {}"
          @submit="handleExtensionSubmit"
          @cancel="handleExtensionCancel"
        />
        <div v-else-if="popup.type == 'ext-list'">
          <h4>Edit extensions</h4>
          <ul class="sm-phone__popup-form-list ext">
            <li
              v-for="ext in extensions"
              :key="ext.extension"
            >
              <div class="item">
                <span>{{ext.extension}}</span>
                <!-- <span>{{ext.name}}</span> -->
                <text-truncate :text="ext.name" />
                <!-- <span>{{ext.forward_to_phone_number}}</span> -->
                <text-truncate :text="ext.forward_to_phone_number" />
                <a @click.stop="extEditStatus = (extEditStatus != ext.extension ? ext.extension : null)">Edit</a>
                <a
                  href="#"
                  class="sm-error"
                  @click.prevent="rmExtension(ext)"
                >Delete</a>
              </div>
              <form-extension
                v-if="extEditStatus == ext.extension"
                :class="'sm-phone__popup-form-inline-form'"
                :title="'Edit extension'"
                :btnText="'Update'"
                :initData="ext"
                @submit="handleExtensionSubmit"
                @cancel="handleExtensionCancel"
              />
            </li>
          </ul>
          <a
            v-if="extEditStatus != 'new'"
            class="sm-phone__popup-form-add-ext"
            :class="{'disabled': extensions.length > 4}"
            @click.stop="extEditStatus = 'new'"
          >
            <include-svg :name="'icon-plus'" />
            <span>Add one more extension</span>
          </a>
          <form-extension
            v-else
            :class="'sm-phone__popup-form-inline-form'"
            :title="'New extension'"
            :btnText="'Add extension'"
            :initData="{}"
            @submit="handleExtensionSubmit"
            @cancel="handleExtensionCancel"
          />
        </div>

        <form
          v-else-if="popup.type == 'out'"
          class="sm-phone__popup-form"
          @submit.prevent="updateOutgoingNumbers"
        >
          <h4>Outgoing calls for {{formatPhoneNumber(phone)}}</h4>
          <div class="sm-phone__popup-form-switch">
            <p class="sm-reg">Enable outgoing calls</p>
            <label class="sm-switcher">
              <input 
                v-model="phoneParams.is_outgoing_call_enabled"
                type="checkbox" 
              />
              <span></span>
            </label>
          </div>
          <div
            class="sm-phone__popup-form-hide"
            :class="phoneParams.is_outgoing_call_enabled ? '' : 'disabled'"
          >
            <p>Enter the phone number you would like to call from.</p>
            <div
              v-for="(number, index) in outgoingNumbers"
              :key="number.id"
              class="sm-phone__popup-form-hide-item"
              @click.stop
              @input="addOutgoingToUpdate(number.id)"
            >
              <phone-input
                v-model="number.caller_phone_number"
                :start_val="number.caller_phone_number"
                :name="`number-${number.id}`"
                :show_errors="true"
                :autocomplete="`number-${number.id}`"
              />
              
              <a
                href="#"
                class="sm-error"
                @click.prevent="removeOutgoing(number, index)"
              >Delete</a>
            </div>
            <a
              href="#"
              class="sm-phone__popup-form-hide-link"
              :class="outgoingNumbers.length > 4 ? 'disabled' : ''"
              @click.prevent="outgoingNumbers.push({})"
            >
              <include-svg :name="'icon-plus'" />
              <span>Add one more number</span>
            </a>
          </div>
          <btn-block 
            :text="'Update'" 
            :class="!phone.is_outgoing_call_enabled && !phoneParams.is_outgoing_call_enabled ? 'disabled' : ''"
            type="submit" 
          />
        </form>
        <confirm-block
          v-else-if="popup.type == 'del'"
          :text="'Do you want to cancel this phone number?'"
          :confirmText="'Confirm'"
          :confirmType="'error'"
          @confirm="deletePhone"
          @cancel="popup.isOpen = false"
        />
      </template>
    </popup-block>

    <sm-spinner :show="showSpinner" />
  </li>
</template>

<script>
import { AsYouType } from 'libphonenumber-js';
import { mapGetters, mapActions } from 'vuex';
import IncludeFlag from '@/components/IncludeFlag';
import Popup from '@/components/Popup';
import PhoneInput from '@/components/PhoneInput';
import InputText from '@/components/InputText';
import vClickOutside from 'v-click-outside';
import HintWrap from '@/components/HintWrap';
import Confirm from '@/components/Confirm';
import FormExtension from '@/components/forms/FormExtension';
import Spinner from '@/components/Spinner';
import ViewPort from '@/mixins/ViewPort';

export default {
  name: 'phone-number',
  components: {
    'include-flag': IncludeFlag,
    'popup-block': Popup,
    'phone-input': PhoneInput,
    'input-text': InputText,
    'hint-wrap': HintWrap,
    'confirm-block': Confirm,
    'form-extension': FormExtension,
    'sm-spinner': Spinner
  },
  props: {
    phone: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      popup: {
        isOpen: false,
        type: '', // values: ext-list, ext-new, ext-edit, out, del
        item: null
      },
      phoneParams: {},
      outgoingNumbers: [],
      outgoingNumbersToUpdate: [],
      outgoingNumbersToRemove: [],
      extensions: [],
      defaultExtension: {
        extension: '',
        name: '',
        forward_to_phone_number: '',
      },
      extEditStatus: null, // values: new or ext.extension
      showSpinner: false,

      allowedBreakpoints: [
        'medium',
        'large'
      ]
    };
  },
  created() {
    this.phoneParams = Object.assign({}, this.phone);
    Promise.all([
      this.getOutgoingNumbers(this.phone.id),
      this.getExtensions(this.phone.id)
    ])
      .then(([outgoing, extensions]) => {
        this.outgoingNumbers = outgoing.phone_outgoing_call_froms;
        this.extensions = extensions.phone_extensions;
      });
  },
  computed: {
    ...mapGetters({
      countryList: 'countryList',
      isDev: 'isDev'
    }),
    extActionText() {
      return this.extensions.length ? 'Manage extensions' : 'Add extension';
    },
    popupSize() {
      if (this.popup.type == 'ext-list')
        return 'large';
      else if (this.popup.type == 'out')
        return 'medium';
      else
        return 'default';
    }
  },
  mixins: [ViewPort],
  methods: {
    ...mapActions({
      getOutgoingNumbers: 'account/getOutgoingNumbers',
      addOutgoingNumber: 'account/addOutgoingNumber',
      updateOutgoingNumber: 'account/updateOutgoingNumber',
      deleteOutgoingNumber: 'account/deleteOutgoingNumber',
      getExtensions: 'account/getExtensions',
      createExtension: 'account/createExtension',
      updateExtension: 'account/updateExtension',
      removeExtension: 'account/removeExtension',
      showGlobalNotification: 'showGlobalNotification',
      updateNumber: 'account/updateNumber',
      deleteNumber: 'account/deleteNumber'
    }),
    formatPhoneNumber(phone) {
      if (phone.phone_number == phone.friendly_name) {
        const asYouType = new AsYouType();
        asYouType.input(phone.phone_number);
        let num = asYouType.getNumber();
        
        //return `+${num.countryCallingCode} ${num.formatNational()}`;
        return `${num.formatNational()}`;
      } else { // Already formated
        return phone.friendly_name;
      }
    },
    getPhoneCountry(phone) {
      let countryCode = this.getPhoneParam(phone, 'country');
      let phoneCountry = this.countryList.find(country => country.code == countryCode);

      return phoneCountry ? phoneCountry.name : '';
    },
    getPhoneParam(phone, param) {
      const asYouType = new AsYouType();
      asYouType.input(phone);

      return asYouType.getNumber()[param];
    },
    showItemPopup(phone) {
      setTimeout(() => {phone.popupOpen = true}, 0);
    },
    
    showPopup(type, ext) {
      this.popup.type = type;
      this.popup.isOpen = true;

      if (type == 'ext-edit')
        this.popup.item = this.extensions.find(item => item.extension == ext);
    },
    handleExtensionSubmit(data) {
      if (this.popup.type == 'ext-new' || this.extEditStatus == 'new') {
        this.addExtension(data);
      } else {
        this.updExtension(data);
      }
    },
    handleExtensionCancel() {
      if (!this.extensions.length) {
        this.popup.isOpen = false;
      } else {
        this.extEditStatus = null;
      }
    },
    addExtension(data) {
      this.showSpinner = true;
      this.createExtension({
        id: this.phone.id,
        ext: {
          phone_extension: data
        }
      })
        .then((res) => {
          this.extensionActionCallback();
          this.extEditStatus = null;
        })
        .catch(e => {
          if (e.response.data.errors)
            this.showGlobalNotification({
              type: 'error',
              value: [JSON.stringify(e.response.data.errors).replace(/[\"\{\}\[\]]/g, '').replace(/,/g, ', ').replace(/:/g, ': ')]
            });
          this.popup.isOpen = false;
          this.extensionActionCallback();
        });
    },
    updExtension(data) {
      let startExt = this.extensions.find(ext => ext.extension == data.extension);
      let toSend = {};

      Object.keys(this.defaultExtension).forEach(key => {
        if (key != 'extension' && startExt[key] != data[key])
          toSend[key] = data[key];
      });

      if (Object.keys(toSend).length) {
        this.showSpinner = true;
        this.updateExtension({
          id: this.phone.id,
          ext_id: data.extension,
          ext: {
            phone_extension: toSend
          }
        })
          .then((res) => {
            this.extensionActionCallback();
            this.extEditStatus = null;
          })
          .catch(e => {
            if (e.response.data.errors)
              this.showGlobalNotification({
                type: 'error',
                value: [JSON.stringify(e.response.data.errors).replace(/[\"\{\}\[\]]/g, '').replace(/,/g, ', ').replace(/:/g, ': ')]
              });
            this.popup.isOpen = false;
            this.extensionActionCallback();
          });
      } else {
        this.popup.type = 'ext-list';
      }
    },
    rmExtension(ext) {
      this.showSpinner = true;
      this.removeExtension({
        id: this.phone.id,
        ext_id: ext.extension
      })
        .then(() => {
          this.extensionActionCallback();
        })
        .catch(e => {
          if (e.response.data.errors)
            this.showGlobalNotification({
              type: 'error',
              value: [JSON.stringify(e.response.data.errors).replace(/[\"\{\}\[\]]/g, '').replace(/,/g, ', ').replace(/:/g, ': ')]
            });
          this.popup.isOpen = false;
          this.extensionActionCallback();
        });
    },
    extensionActionCallback() {
      this.getExtensions(this.phone.id)
        .then((res) => {
          this.extensions = res.phone_extensions;
          this.showSpinner = false;
        });
    },
    updateOutgoingNumbers() {
      this.$validator.validate().then(valid => {
        if (!valid)
          return;

        this.showSpinner = true;

        new Promise((resolve, reject) => {
          let resolveTries = 0;
          const tryResolve = () => {
            resolveTries--;
            
            if (!resolveTries)
              resolve();
          }

          if (this.phoneParams.is_outgoing_call_enabled != this.phone.is_outgoing_call_enabled) {
            resolveTries++;
            this.updateNumber({
              id: this.phone.id,
              params: {
                is_outgoing_call_enabled: this.phoneParams.is_outgoing_call_enabled
              }
            })
              .then(res => tryResolve())
              .catch(e => tryResolve());
          }

          this.outgoingNumbers.forEach(phone => {
            if (phone.id) { // Update
              if (!this.outgoingNumbersToUpdate.includes(phone.id) || !phone.caller_phone_number.length)
                return;

              resolveTries++;
              this.updateOutgoingNumber({
                id: this.phone.id,
                params: phone
              })
                .then(res => tryResolve())
                .catch(e => tryResolve());
            } else { // Add
              resolveTries++;
              this.addOutgoingNumber({
                id: this.phone.id,
                params: phone
              })
                .then(res => tryResolve())
                .catch(e => tryResolve());
            }
          });

          this.outgoingNumbersToUpdate = [];

          if (this.outgoingNumbersToRemove.length) {
            this.outgoingNumbersToRemove.forEach(id => {
              // Remove
              resolveTries++;
              this.deleteOutgoingNumber({
                id: this.phone.id,
                outgoing_id: id
              })
                .then(res => tryResolve())
                .catch(e => tryResolve());
            });

            this.outgoingNumbersToRemove = [];
          }

          resolveTries++;
          tryResolve();
        })
          .then(() => {
            this.getOutgoingNumbers(this.phone.id)
              .then(res => {
                this.outgoingNumbers = res.phone_outgoing_call_froms;
                this.popup.isOpen = false;
                this.showSpinner = false;
              });
          });
      });
    },
    addOutgoingToUpdate(id) {
      if (!this.outgoingNumbersToUpdate.includes(id))
        this.outgoingNumbersToUpdate.push(id);
    },
    removeOutgoing(number, index) {
      this.outgoingNumbers.splice(index, 1);

      if (number.id) {
        this.outgoingNumbersToRemove.push(number.id);
      }
    },
    deletePhone() {
      this.showSpinner = true;
      this.deleteNumber(this.phone.id)
        .then((res) => {
          this.$emit('update');
          this.showSpinner = false;
          this.popup.isOpen = false;
        }).
        catch((e) => {
          this.showSpinner = false;
        });
    },
    hidePopups() {
      this.$emit('hidePopups');
    },
    goToEdit() {
      this.$router.push(`phone-setup/${this.phone.id}`);
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
}
</script>